import APIconsume from 'Main/APIconsume'

const DASHBOARD_BASE_URL = '/api/dashboard/api-callback'
const CALLBACK_BASE_URL = '/bank/api-callback'

class ApiCallbackService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  /** GET /api/dashboard/api-callback */
  async getData () {
    const result = await this._apiConsume.getData(DASHBOARD_BASE_URL)
    return result?.data
  }

  /** GET /api/dashboard/api-callback/:id */
  async getById (id) {
    const result = await this._apiConsume.getData(`${DASHBOARD_BASE_URL}/${id}`)
    return result?.data
  }

  /** POST /bank/api-callback */
  async create (payload) {
    const result = await this._apiConsume.postData({
      deviceName: payload.device_name,
      endpoint: payload.endpoint,
      token: payload.token,
      isGlobalCallback: payload.is_global_callback
    }, CALLBACK_BASE_URL)
    return result?.data
  }

  /** PUT /bank/api-callback/:id */
  async update (id, payload) {
    const result = await this._apiConsume.putData({
      device_name: payload.device_name,
      endpoint: payload.endpoint,
      token: payload.token,
      isGlobalCallback: payload.is_global_callback
    }, `${CALLBACK_BASE_URL}/${id}`)
    return result?.data
  }

  /** DELETE /bank/api-callback/:id */
  async deleteById (id) {
    const result = await this._apiConsume.deleteData(`${CALLBACK_BASE_URL}/${id}`)
    return result?.data
  }
}

export default ApiCallbackService
